import { render, staticRenderFns } from "./Businesses.vue?vue&type=template&id=77c41a64&scoped=true&"
import script from "./Businesses.vue?vue&type=script&lang=js&"
export * from "./Businesses.vue?vue&type=script&lang=js&"
import style0 from "./Businesses.vue?vue&type=style&index=0&id=77c41a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c41a64",
  null
  
)

export default component.exports